export const getRoundedMoneyValue = (p: { [key: string]: any }, key: string, round: number = 3): [number, string] | [null, null] => {
    const result: [number, string] = [0.0, "руб."];

    const findedKey = Object.keys(p).find(k => k.toLowerCase() === key.toLowerCase());

    if (findedKey) {
        if (p[findedKey]) {
            const cost = Number.parseInt(`${p[findedKey]}`.split('.')[0]);
            if (cost > Math.pow(10, 6)) {
                result[0] = Number.parseFloat((cost / Math.pow(10, 6)).toFixed(round));
                result[1] = "млн. руб.";
            }
            else if (cost > Math.pow(10, 3)) {
                result[0] = Number.parseFloat((cost / Math.pow(10, 3)).toFixed(round));
                result[1] = "тыс. руб.";
            }
            else {
                result[0] = cost;
            }
        }

        return result;
    }

    return [null, null];

}